<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{info.detail.backTitle}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="info.detail.backUrl">{{info.detail.backTitle}}</a>
        </li>
      </ol>
    </div>

<!-- 상세 -->
    <div class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
        <table class="table table-bordered table-hover">
          <colgroup>
                <col width="12%" class="bg-lightdark" />
                <col width="38%" />
                <col width="12%" class="bg-lightdark" />
                <col width="38%" />
            </colgroup>
          <tbody>
              <tr>
                  <td class="align-middle text-center">받는사람</td>
                  <td class="align-middle" colspan="3">
                      {{`${info.detail.name} (${info.detail.email})`}}
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center">예약설정</td>
                  <td class="align-middle" colspan="3">
                    <div class="no-margin row">
                      <div class="col-auto">
                        <b-form-radio-group class="mt-2 mb-1"
                          v-model="params.sendType"
                          name="send-type-radio"
                        >
                          <b-form-radio value="now">즉시 발송</b-form-radio>
                          <b-form-radio value="later">예약 발송</b-form-radio>
                        </b-form-radio-group>
                      </div>
                      <div class="col-auto">
                        <datepicker 
                            v-model="params.sendDate"
                            :disabled="params.sendDate===null"
                            format="yyyy-MM-dd" 
                            :bootstrapStyling="true"
                            :monday-first="true"
                            :full-month-name="true"
                            placeholder="날짜 선택"
                            :calendar-button="true"
                            calendar-button-icon="far fa-calendar"
                            :clear-button="false"
                            width="300px" >
                        </datepicker>
                      </div>
                      <div class="col-auto">
                        <b-form-timepicker 
                          v-model="params.sendTime"
                          :disabled="params.sendTime.length==0"
                          placeholder="시간 선택">
                        </b-form-timepicker>
                      </div>
                    </div>
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center">제목</td>
                  <td class="align-middle" colspan="3">
                      <input type="text" v-model="params.subject" class="form-control" 
                      v-validate="'required|min:3'"  name="subject" style="width: 100%"  />
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center report-title">신고내용</td>
                  <td class="align-middle report-content" colspan="3">
                      {{info.detail.report}}
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center report-title">신고일</td>
                  <td class="align-middle report-content" colspan="3">
                      {{info.detail.regDt}}
                  </td>
              </tr>
              <tr>
                  <td class="align-middle text-center report-title">대상 게시물</td>
                  <td class="align-middle report-content" colspan="3">
                      {{info.detail.title}}
                  </td>
              </tr>
              <tr>
                <td class="align-middle text-center">내용</td>
                <td class="align-middle text-center" colspan="3">
                   <quill-editor
                      ref="myQuillEditor"
                      v-model="params.text"
                      v-validate="'required|min:10'"
                      name="text"
                      :style="'min-height:300px'"
                    /> 
                </td>
            </tr> 
          </tbody>
        </table>
      </div>
      
      <div class="footer mt-2 mb-3">
        <div class="float-right">
          <b-button @click="sendEmail()" class="btn btn-b btn-info mr-2" variant="info mr-2">발송</b-button>
          <b-button @click="list()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>  
        </div>
      </div>
    </div>

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<style scoped>
  .report-title {
    background-color:#e3e3e3 !important;
    color:brown;
  }

  .report-content {
    background-color:#e3e3e3 !important;
  }
</style>
<script>
import Vue from 'vue'
import store from '@/store/index'
import { reactive, ref, computed, watch, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {sendWarnEmail} from "@/api/community/CommunityAPI";
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// Editor
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor)

export default {
    components: {Loading, Datepicker},
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);
      
      const info = reactive({
        detail: {}
      });

      const params = reactive({
        sendType: 'now',
        sendDate: null,
        sendTime: '',
        subject: '',
        text:''
      })

      const retVals = {
        isTest,
        modalLoading,
        info,
        params,
        ...methods(),
      }
      onMounted(() => {
        retVals.detail(root.$router);
      });
      watch(() => params.sendType, (newValue, oldValue) => {
        console.log('params.sendType: ', {newValue, oldValue})

        if (newValue == 'later') {
          const now = new Date();
          params.sendDate = now;
          params.sendTime = moment(now).add(1, 'hour').format('HH:mm');
        } else {
          params.sendDate = null;
          params.sendTime = '';
        }
      })

      return retVals;
    }
}

function methods() {

  // 상세
  function detail(router){
    if (store.state.detail.name == 'sendEmail') {
        console.log('detail data: ', store.state.detail.data);
        this.info.detail = store.state.detail.data;
    } else {
      console.log('sendEmail detail : no detail information');
      router.go(-1);
    }
  }

  async function sendEmail() {
    // validation
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      //console.log('validator:', this.$validator);
      const allErrors = this.$validator.errors.all();
      if (allErrors.length > 0) {
        alert(allErrors.join('\n'));
      }
      return;
    }

    // set parameter
    const params = this.params;
    if (!params.sendDate) {
      params.sendDate = '';
    }
    if (params.sendType == 'later') {
      params.sendDate = moment(params.sendDate).format('YYYY-MM-DD');
    }
    params.toAddr = this.info.detail.email;
    params.reservationDt = `${params.sendDate} ${params.sendTime}`;

    console.log('sendEmail:', params);

    // send
    try {
      const result = await sendWarnEmail(params, this.isTest);
      if (params.sendType == 'now') {
        alert('이메일이 발송되었습니다.');
      } else {
        alert('이메일 발송이 예약되었습니다.');
      }
      this.$router.go(-1);
    } catch (e) {
      alert(`실패했습니다.:${e.message}`);
    }
  }

  function list() {
    this.$router.go(-1);
  }

  return {
    detail,
    sendEmail,
    list,
  }
}
</script>